/**
 * @generated SignedSource<<2ab0c7a59301aae0873e2a4073da2b29>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "tradePointId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      },
      {
        "kind": "Variable",
        "name": "tradePointId",
        "variableName": "tradePointId"
      }
    ],
    "concreteType": "TradeRule",
    "kind": "LinkedField",
    "name": "acceptNominatedTrade",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "acceptedAt",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "User",
        "kind": "LinkedField",
        "name": "acceptedBy",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "email",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "givenName",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "familyName",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "AcceptNominatedTradeMutation",
    "selections": (v2/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "AcceptNominatedTradeMutation",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "966cafcdc106190bb727b8352ce83dbf",
    "id": null,
    "metadata": {},
    "name": "AcceptNominatedTradeMutation",
    "operationKind": "mutation",
    "text": "mutation AcceptNominatedTradeMutation(\n  $id: ID!\n  $tradePointId: String!\n) {\n  acceptNominatedTrade(id: $id, tradePointId: $tradePointId) {\n    id\n    acceptedAt\n    acceptedBy {\n      id\n      email\n      givenName\n      familyName\n    }\n  }\n}\n"
  }
};
})();

node.hash = "9a552b647dbc2da88ad1b504f10ea55d";

module.exports = node;
